/* Packages */
import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import useFlowContext from "../hooks/useFlowContext";

/* Hooks */
import useValidation from '../hooks/useValidation';

export default function FlowFieldChoice(props) {
    const { colClassName, field, inputType, path, id, updateChoice } = props;
    const { type, label, choices, required, disabled, placeholder = null, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const {
        translate = () => {},
    } = useFlowContext();

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    return (
        <div className={`${colClassName}`}>
            <Form.Group className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }
                {choices?.map((choice, choiceIndex) => {
                    return (
                        <Form.Check
                            key={choice.key}
                            className={`custom-control custom-${inputType} ${error ? 'is-error' : ''}`}
                            type={inputType}
                            id={`${id}.choices.${choiceIndex}-${choice.key}`}
                        >
                            <Form.Check.Input
                                type={inputType}
                                className="custom-control-input"
                                name={id}
                                value={choice.key}
                                {...{
                                    required,
                                    disabled,
                                    placeholder,
                                }}
                                checked={value?.includes(choice.key)}
                                onChange={(e) => {
                                    updateChoice(choice, e.target.checked, () => {
                                        trigger(path);
                                    });
                                }}
                            />
                            <Form.Check.Label className="custom-control-label" dangerouslySetInnerHTML={{ __html: choice.label }} />
                        </Form.Check>
                    );
                })}
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
